import { AppBar, Toolbar, Typography, styled, Box, Link } from "@mui/material";
import React from "react";
import { NavLink } from "react-router-dom";
import LogoIcon from "./LogoIcon";
import AccountButton from "./Account/AccountButton";

const StyledAppBar = styled(AppBar)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

const StyledText = styled(Typography)(({ theme }) => ({
  display: "inline",
  "& > *": {
    textDecoration: "none",
    textTransform: "uppercase",
    color: theme.palette.text.secondary,
  },
  "& .active": {
    color: theme.palette.primary.main,
  },
}));

const Logo = styled(Link)(() => ({
  display: "flex",
  alignItems: "center",
  cursor: "pointer",
  textDecoration: "none",
}));

const Header = () => {
  return (
    <StyledAppBar color="inherit" elevation={0} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}>
      <Toolbar>
        <Logo href="/">
          <LogoIcon fontSize="large" color="primary" />
          <Typography
            color="text.primary"
            variant="h6"
            component="span"
            ml={1.5}
            fontWeight={600}
            letterSpacing={-0.2}
          >
            Rousen Map
          </Typography>
        </Logo>
        <Box flexGrow={1} ml={4}>
          <StyledText variant="subtitle2" mr={3}>
            <NavLink to="/docs">API Document</NavLink>
          </StyledText>
          <StyledText variant="subtitle2" mr={3}>
            <NavLink to="/changelog">Change Log</NavLink>
          </StyledText>
          <StyledText variant="subtitle2" mr={3}>
            <NavLink to="/faq">Faq</NavLink>
          </StyledText>
          <StyledText variant="subtitle2" mr={3}>
            <NavLink to="http://route.citus.co.kr">Maps</NavLink>
          </StyledText>
        </Box>
        <AccountButton />
      </Toolbar>
    </StyledAppBar>
  );
};

export default Header;
